module.exports = __webpack_public_path__ + "static/upstack-f146ba1734bd34fd6f523b81d7dcd004.png";